var _defs, _tspan, _tspan2, _tspan3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLecture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg7877",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.626953 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1769",
    d: "M22.105742 415.87717h21.899145v53.508289H22.105742z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lecture",
    transform: "matrix(8.32756 0 0 8.32756 -324.50574 -198.75851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1303",
    style: {
      fill: "#4d4d4d",
      strokeWidth: 0.212716
    },
    d: "m43.083356 23.86756-2.069324 1.056123.836595 1.665451.386049-.004v1.672721H41.04288v1.159554h1.193796v3.649873h1.82306v-3.649873h1.159319v-1.159554h-1.159319v-1.691484l.377136-.004.761778-1.682104z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path836",
    style: {
      fill: "maroon",
      strokeWidth: 0.213605
    },
    d: "M43.082418 32.07051a3.8633163 4.9356112 0 0 0-3.855797 4.644781h-.0075v21.159038a4.1204276 1.5021427 0 0 0-.251424.515982 4.1204276 1.5021427 0 0 0 4.120355 1.502213 4.1204276 1.5021427 0 0 0 4.12059-1.502213 4.1204276 1.5021427 0 0 0-.257288-.52208v-21.15294h-.01243a3.8633163 4.9356112 0 0 0-3.856506-4.644781Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666",
      strokeWidth: 0.306204
    },
    id: "rect1697",
    d: "M39.706577 37.801476h6.7780609v20.206371H39.706577z"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text1767",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "13.3333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      whiteSpace: "pre",
      shapeInside: "url(#rect1769)",
      display: "inline",
      fill: "#000"
    },
    transform: "matrix(.26458 0 0 .35437 35.83945 -108.63902)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 22.105469,
    y: 428.04133,
    id: "tspan157"
  }, "O\n")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 22.105469,
    y: 444.70795,
    id: "tspan159"
  }, "C\n")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 22.105469,
    y: 461.37458,
    id: "tspan161"
  }, "S")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecture);
export default __webpack_public_path__ + "static/media/lecture.21d12b0b53f98450a4a10130efcf3c1b.svg";
export { ForwardRef as ReactComponent };